import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from '../authentication';
import { AuthGuard } from '@app/core/guards/auth.guard';

@Injectable({ providedIn: 'root' })
export class PersonalAuthGuard extends AuthGuard implements CanActivate {
    constructor(
        protected router: Router,
        protected authenticationService: AuthenticationService
    ) {
        super(router, authenticationService);
    }
}
